import { toDisplayString as _toDisplayString, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wizard-panels" }
const _hoisted_2 = { class: "wizard-panels__left d-flex flex-column" }
const _hoisted_3 = { class: "d-flex align-items-center fs-18 mb-4" }
const _hoisted_4 = { class: "mr-1" }
const _hoisted_5 = { class: "wizard-panels__right p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SceneStepItemsList = _resolveComponent("SceneStepItemsList")
  const _component_ScenePanelObjects = _resolveComponent("ScenePanelObjects")
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_ScenePanelTime = _resolveComponent("ScenePanelTime")
  const _component_TabView = _resolveComponent("TabView")
  const _component_DialogAddTriggerAndCondition = _resolveComponent("DialogAddTriggerAndCondition")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("strong", _hoisted_4, _toDisplayString(_ctx.scene.conditions.length), 1),
          _createVNode("span", null, _toDisplayString(_ctx.conditionText), 1)
        ]),
        _createVNode(_component_SceneStepItemsList, {
          items: _ctx.scene.conditions,
          onEdit: _ctx.handleEdit,
          onRemove: _ctx.handleRemove,
          class: "flex-shrink-1"
        }, null, 8, ["items", "onEdit", "onRemove"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_TabView, { class: "p-tabview--custom" }, {
          default: _withCtx(() => [
            _createVNode(_component_TabPanel, {
              header: _ctx.$t('AppResource.ObjectCapitalized')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ScenePanelObjects, {
                  roomsWithObjects: _ctx.conditionsList,
                  "step-to-add": _ctx.SceneWizardStepEnum.STEP_CONDITION,
                  onAddCondition: _ctx.handleAddCondition
                }, null, 8, ["roomsWithObjects", "step-to-add", "onAddCondition"])
              ]),
              _: 1
            }, 8, ["header"]),
            _createVNode(_component_TabPanel, {
              header: _ctx.$t('AppResource.Time')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ScenePanelTime, {
                  name: "Time",
                  "step-to-add": _ctx.SceneWizardStepEnum.STEP_CONDITION,
                  onAddCondition: _ctx.handleAddCondition
                }, null, 8, ["step-to-add", "onAddCondition"])
              ]),
              _: 1
            }, 8, ["header"])
          ]),
          _: 1
        })
      ])
    ]),
    _createVNode(_component_DialogAddTriggerAndCondition, {
      "is-visible": _ctx.isVisibleDialogCondition,
      "onUpdate:is-visible": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isVisibleDialogCondition = $event)),
      onConfirm: _ctx.handleDoEditCondition,
      "step-to-add": _ctx.SceneWizardStepEnum.STEP_CONDITION,
      triggerOrActionToAdd: _ctx.tempConditionToEdit,
      triggerOrConditionType: 
            _ctx.tempConditionDTOToEdit ? _ctx.tempConditionDTOToEdit.sceneObjectType : null
        ,
      triggerOrConditionName: 
            _ctx.tempConditionDTOToEdit ? _ctx.tempConditionDTOToEdit.objectName : null
        
    }, null, 8, ["is-visible", "onConfirm", "step-to-add", "triggerOrActionToAdd", "triggerOrConditionType", "triggerOrConditionName"])
  ], 64))
}